import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 16l4 -4","key":"svg-0"}],["path",{"d":"M18 16l-4 -4","key":"svg-1"}],["path",{"d":"M6 10a2 2 0 1 1 4 0c0 .591 -.417 1.318 -.816 1.858l-3.184 4.143l4 0","key":"svg-2"}]]

const IconMultiplier2x = createReactComponent('outline', 'multiplier-2x', 'Multiplier2x', __iconNode);

export default IconMultiplier2x;